import Box from '@mui/material/Box';
import { flexCenter } from '../commonUI/cssClasses';
import LoadingPlant from '../commonUI/LoadingPlant/LoadingPlant';

const LoadingPlantPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        ...flexCenter,
      }}
    >
      <LoadingPlant />
    </Box>
  );
};

export default LoadingPlantPage;
